export default {"src":"/_next/static/media/footer-qr.7e47183b.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};